module.exports = __webpack_public_path__ + "static/media/big-logo.97b822ec.svg";